import { trunc } from './math';
import { getRoundValue } from './math/rounding';

/**
 * Returns array of rounded values of approximate length
 */
export function getSegments(from: number, to: number, length = 10): number[] {
  const interval = (to - from) / (length - 1);
  const roundValue = getRoundValue(interval);
  let result = [from];
  let next = roundValue;
  if (from >= roundValue) {
    next = from - (from % roundValue) + roundValue;
  }
  while (next < to) {
    result.push(next);
    next += roundValue;
  }
  result.push(to);

  if (result.length >= 16) {
    // split in half
    result = result.reduce((acc, val, index) => {
      if (index === 0 || index === result.length - 1) {
        acc.push(val);
      } else if (index % 2) {
        acc.push(val);
      }
      return acc;
    }, []);
  }

  return result;
}

export function getDataPoints(
  from: number,
  to: number,
  length: number,
): number[] {
  const interval = (to - from) / length;

  return Array.from(new Array(length + 1)).map((_, index) => {
    const value = from + index * interval;
    if (index === 0 || index === length) {
      return value;
    }
    return trunc(value);
  });
}

/**
 * Returns array of values with an interval of `step` starting with nearest `step` value
 */
export function getStepValues(from: number, to: number, step = 10): number[] {
  const result = [];
  let value = from !== 0 ? Math.ceil(from / step) * step : step;
  while (value < to) {
    result.push(value);
    value += step;
  }
  result.push(to);
  return result;
}
